import { render } from "./ScreenComponent.vue?vue&type=template&id=b0bff772&scoped=true&ts=true"
import script from "./ScreenComponent.vue?vue&type=script&lang=ts"
export * from "./ScreenComponent.vue?vue&type=script&lang=ts"

import "./ScreenComponent.vue?vue&type=style&index=0&id=b0bff772&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bff772"]])

export default __exports__